import async from '@/base/components/Async';
import IRouteItem from './IRouteItem';

const basicLayout = async(() => import('@/base/layout/BasicLayout'));

const routeConfig: IRouteItem[] = [
  {
    name: '主页',
    path: '/',
    component: basicLayout,
    children: [
      {
        path: '/vela',
        component: async(() => import('@/pages/IndexPage')),
      },
    ],
  },
];

export const MENU_LIST: IRouteItem[] = routeConfig[0].children || [];

export default routeConfig;
